<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <h4 class="mt-3 text-left">Keyword NLP Phrases</h4>
          <b-input-group class="mt-3">
            <template v-slot:prepend>
              <b-form-group style="width: 100px;">
                <v-select
                  :disabled="searchPage"
                  :searchable="true"
                  :clearable="true"
                  label="text"
                  :options="futureRiskTab ? $store.state.priConfigrationforms.futureRisks.categories[categoriesIndex].searchKeywords : $store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].searchKeywords"
                  v-model="selectedSearchKeywordNlp"
                ></v-select>
              </b-form-group>
            </template>

            <b-form-input
              :disabled="searchPage"
              placeholder="Enter the entity name you would like to search..."
              @keyup.enter="addAdditionalKeywordPhrasesNlp()"
              v-model="addKeyWordNlp"
              style="height: 35px;"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="searchPage"
                @click="addAdditionalKeywordPhrasesNlp"
                variant="outline-warning"
                style="height: 35px;"
              >Add</b-button>
            </b-input-group-append>
          </b-input-group>

          <b-table
            :items="futureRiskTab ? $store.state.priConfigrationforms.futureRisks.categories[categoriesIndex].searchKeywordsNlp : $store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].searchKeywordsNlp"
            :fields="fieldsKeywordsNlp"
          >
            <template v-slot:cell(text)="data">
              <p>{{data.item}}</p>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                :disabled="searchPage"
                @click="removeAdditionalKeywordPhrasesNlp(data)"
                variant="danger"
                size="sm"
              >
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
export default {
  name: "NaturalLanguageProcessingComponent",
  data() {
    return {
      selectedSearchKeywordNlp: null,
      fieldsKeywordsNlp: [
        { key: "keyword", label: "Keyword" },
        { key: "keywordNlp", label: "NLP Phrase" },
        { key: "Actions", label: "Actions" }
      ],
      addKeyWordNlp: null
    };
  },
  methods: {
    addAdditionalKeywordPhrasesNlp() {
      if (this.addKeyWordNlp) {
        let searchKeywordsNlpData = this.futureRiskTab
          ? this.$store.state.priConfigrationforms.futureRisks.categories[
              this.categoriesIndex
            ].searchKeywordsNlp
          : this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].searchKeywordsNlp;
        let set = {
          keywordNlp: this.addKeyWordNlp,
          keyword: this.selectedSearchKeywordNlp
        };
        searchKeywordsNlpData.unshift(set);
      }
      this.selectedSearchKeywordNlp = null;
      this.addKeyWordNlp = null;
    },
    removeAdditionalKeywordPhrasesNlp(data) {
      let searchKeywordsNlpData = this.futureRiskTab
        ? this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchKeywordsNlp
        : this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchKeywordsNlp;
      let searchKeywordsNlpIndex = searchKeywordsNlpData.indexOf(data.item);
      searchKeywordsNlpData.splice(searchKeywordsNlpIndex, 1);
    }
  },
  props: {
    futureRiskTab: Boolean,
    negativeMediaTab: Boolean,
    categoriesIndex: Number,
    negativeMediaEdit: Boolean,
    futureRisksEdit: Boolean,
    searchPage: Boolean
  }
};
</script>